export default {
  NEW: 0,
  MODERATED: 1,
  OPERATED: 2,
  ACCEPTED: 3,
  DECLINED: 4
};